<template>
  <div>
    {{ notificationStart }} prices for a
    <strong v-html="policyType" />
    <strong> policy </strong>to
    <strong v-html="tripDestination" />
    from
    <strong>{{ formattedPolicyStartDate }} </strong>
    <span v-if="policyType === 'Single Trip' && policyEndDate">to
      <strong>{{ formattedPolicyEndDate }}</strong>
    </span>
  </div>
</template>

<script>
import {
  UtcDate,
  DATE_FORMAT,
} from '@/helpers/date';

export default {
  name: 'results-notification',
  props: {
    partnerText: {
      type: String,
      default: null,
    },
    insurerName: {
      type: String,
      default: null,
    },
    policyType: {
      type: String,
      default: null,
    },
    tripDestination: {
      type: String,
      default: null,
    },
    policyStartDate: {
      type: String,
      default: null,
    },
    policyEndDate: {
      type: String,
      default: null,
    },
  },
  computed: {
    notificationStart () {
      if (this.partnerText) return this.partnerText;

      return `${this.insurerName ? `${this.insurerName}, we're` : 'We\'re'} showing you`;
    },
    formattedPolicyStartDate () {
      return this.formatDate(this.policyStartDate);
    },
    formattedPolicyEndDate () {
      return this.formatDate(this.policyEndDate);
    },
  },
  methods: {
    formatDate (date) {
      const parsedDate = new UtcDate().parse(date, DATE_FORMAT);
      if (parsedDate.isValid()) return parsedDate.format('do LLLL yyyy');
      return date;
    },
  },
};
</script>
